import * as React from 'react';
import { LegacyPlaceholderBusinessImage } from '@tock/images';
import { Theme, css } from '@emotion/react';
import { Typography } from 'omakase';
import { consumer } from '@tock/coretypes';
import { getBusinessSubtitle, getBusinessThumbnailSrc } from 'utils/businessUtils';

const overall = ({ borderRadius, colors, shadow }: Theme) => css`
  background-color: ${colors.bgDefault};
  border-radius: ${borderRadius[100]};
  box-shadow: ${shadow[100]};
  width: 100%;
  overflow: hidden;
`;

const thumb =
  (imgSrc: string) =>
  ({ borderRadius, mediaRatios }: Theme) => css`
    border-top-left-radius: ${borderRadius[100]};
    border-top-right-radius: ${borderRadius[100]};
    height: 0;
    padding-top: ${mediaRatios.oneEightFiveOne};
    background-image: url(${imgSrc});
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  `;

const content = ({ spacing }: Theme) => css`
  padding: ${spacing(2)}px;
  text-align: left;
`;

interface Props {
  business: consumer.OfferingBusiness;
  onBookNow(): void;
}

const AvailabilitySearchResultsMapResult: React.FunctionComponent<Props> = ({
  business,
  onBookNow,
}) => {
  const imgSrc =
    getBusinessThumbnailSrc(business, { height: 384, width: 576 }) ||
    LegacyPlaceholderBusinessImage;
  const subtitle = getBusinessSubtitle(business, { excludes: { locality: true } });

  return (
    <button aria-label={`Book experience for ${business.name}`} onClick={onBookNow} css={overall}>
      <div css={thumb(imgSrc)} role="img" />
      <section css={content}>
        <Typography component="h5" variant="heading03" noWrap mb={0.5}>
          {business.name}
        </Typography>
        <Typography noWrap color="fgSubtle" variant="body02">
          {subtitle}
        </Typography>
      </section>
    </button>
  );
};

export default AvailabilitySearchResultsMapResult;
